import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-aprovacao-comercial',
    templateUrl: './aprovacao-comercial.component.html',
    styleUrls: ['./aprovacao-comercial.component.css']
})
export class AprovacaoComercialComponent implements OnInit {

    constructor() { }

    ngOnInit() {

    }

}
